import React from 'react';
import style from "./common.module.scss";
import { t } from "i18next";
import OrderStatusDropdown from './GroupByDropdown/OrderStatusDropdown';
import { CURRENCIES } from '../../../mock';

const ShippingRoutesTable = ({ top10DirectionsTable = [], isExpeditor = false, isCompleted = true, setIsCompleted, currency }) => {
  const data = top10DirectionsTable;
  const isNoCurrency = currency === "all" || currency === "";

  const getCityNames = (routeName) => {
    const cities = routeName.split(' - ');
    return {
      from: cities[0],
      to: cities[1]
    };
  };

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const formatDeliveryTime = (minutes) => {
    if (!minutes || minutes === 0) return `0 ${t("common.datetime.minutesShort")}`;
    
    const totalMinutes = Math.round(minutes);
    
    // Если меньше часа - показываем минуты
    if (totalMinutes < 60) {
      return `${totalMinutes} ${t("common.datetime.minutesShort")}`;
    }
    
    // Если меньше суток - показываем часы и минуты
    if (totalMinutes < 1440) { // 1440 = 24 * 60
      const hours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      
      if (remainingMinutes === 0) {
        return `${hours} ${t("common.datetime.hoursShort")}`;
      }
      return `${hours} ${t("common.datetime.hoursShort")} ${remainingMinutes} ${t("common.datetime.minutesShort")}`;
    }
    
    // Если больше суток - показываем дни и часы
    const days = Math.floor(totalMinutes / 1440);
    const remainingHours = Math.floor((totalMinutes % 1440) / 60);
    
    if (remainingHours === 0) {
      return `${days} ${t("common.datetime.daysShort")}`;
    }
    return `${days} ${t("common.datetime.daysShort")} ${remainingHours} ${t("common.datetime.hoursShort")}`;
  };

  return (
    <div className={style.table}>
      {isExpeditor && <div className={style.table_Dropdown}> <OrderStatusDropdown isCompleted={isCompleted} setIsCompleted={setIsCompleted} /></div>}
      <table className={style.table_element}>
        <thead className={style.table_head}>
        <tr>
          <th className={style.table_header_cell}>{t("analytics.departureCity")}</th>
          <th className={style.table_header_cell}>{t("analytics.arrivalCity")}</th>
          <th className={style.table_header_cell_less}>{t("analytics.carrierCount")}</th>
          <th className={style.table_header_cell_less}>{t("analytics.applicationCount")}</th>
          <th className={style.table_header_cell_less}>{t("analytics.tenderShare")}</th>
          <th className={style.table_header_cell}>{t("analytics.turnover") + (CURRENCIES[currency]?.symbol ? ` (${CURRENCIES[currency]?.symbol})` : "")}</th>
          <th className={style.table_header_cell}>{t("analytics.averageCheck") + (CURRENCIES[currency]?.symbol ? ` (${CURRENCIES[currency]?.symbol})` : "")}</th>
          <th className={style.table_header_cell}>{t("analytics.minCheck") + (CURRENCIES[currency]?.symbol ? ` (${CURRENCIES[currency]?.symbol})` : "")}</th>
          <th className={style.table_header_cell}>{t("analytics.maxCheck") + (CURRENCIES[currency]?.symbol ? ` (${CURRENCIES[currency]?.symbol})` : "")}</th>
          <th className={style.table_header_cell}>{t("analytics.minDeliveryTime")}</th>
          <th className={style.table_header_cell}>{t("analytics.maxDeliveryTime")}</th>
          <th className={style.table_header_cell}>{t("analytics.avgDeliveryTime")}</th>
        </tr>
        </thead>
        <tbody>
        {data.slice(0, 10).map((row, index) => {
          const cities = getCityNames(row.routeName);
          const averagePrice = Math.round(row.totalPrice / row.count);
          const rowClass = index === 0 ? style.table_row : style.table_row;

          return (
            <tr key={index} className={rowClass}>
              <td className={style.table_cell}>{cities.from}</td>
              <td className={style.table_cell}>{cities.to}</td>
              <td className={style.table_cell}>{row.expeditor}</td>
              <td className={style.table_cell}>{row.count}</td>
              <td className={style.table_cell}>{row.tenderCount}</td>
              <td className={style.table_cell}>{isNoCurrency ? "-" : formatNumber(Math.round(row.totalPrice))}</td>
              <td className={style.table_cell}>{isNoCurrency ? "-" : formatNumber(Math.round(averagePrice))}</td>
              <td className={style.table_cell}>{isNoCurrency ? "-" : formatNumber(row.minPrice)}</td>
              <td className={style.table_cell}>{isNoCurrency ? "-" : formatNumber(row.maxPrice)}</td>
              <td className={style.table_cell}>{formatDeliveryTime(row.minDeliveryTime)}</td>
              <td className={style.table_cell}>{formatDeliveryTime(row.maxDeliveryTime)}</td>
              <td className={style.table_cell}>{formatDeliveryTime(row.avgDeliveryTime)}</td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
  );
};

export default ShippingRoutesTable;